import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Form } from 'formsy-react' // eslint-disable-line
import PropTypes from 'prop-types'
import {
  clone,
  findIndex,
  isEmpty,
  propEq,
} from 'ramda'
import {
  Button,
  Checkbox,
  Modal,
  SelectSearch,
  TextInput,
} from 'advenio-components'

import ChargesTable from './ChargesTable'
import BalanceActions from '../../../Data/Redux/BalanceRedux'
import { Selectors as ClassroomSelectors } from '../../../Data/Redux/ClassroomRedux'

import ConsumbalesActions from '../../../Data/Redux/ConsumablesRedux'

// unit_price_price = precio unitario sin IVA ( se usa para sacar el unit_price de la cuenta)
// tax_amout = se utiliza para sacar el IVA total
// total_price = se utitliza para sacar el costo total y el monto de cada elemento

const ConceptInputs = styled.div`
  width: 340px;
`
const InputRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`
const QuantityInput = styled.div`
  width: ${({ width }) => width || '65px'};
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 32px 16px;
`

class AddChargeModal extends Component {
  state = {
    consumableOptions: [],
    itemsToBeCharged: [],
    selectedConsumable: '',
    selectedQty: '',
  }

  componentDidMount() {
    const { student,user } = this.props
    this.props.getConsumables(user.center_id, student.id)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.consumables.length !== this.props.consumables.length
      || isEmpty(this.state.consumableOptions)
    ) {
      // `id` alone is not a unique key across this list — CenterConsumable and
      // TuitionFeeType are separate tables and their ids can collide (e.g. both
      // can have id=4). SelectSearch's internal Options component uses `id` as
      // the React `key`, so a raw colliding id causes React to misreconcile
      // list items on filter/re-render (duplicated/ghost rows in the dropdown).
      // We use the same synthetic `${type}_${id}` for both `id` and `value` so
      // every option is truly unique. The original numeric `id`/`type` are kept
      // separately to resolve the exact record on submit.
      const consumableOptions = nextProps.consumables.map(({ id, type, consumable }) => ({
        id: `${type}_${id}`,
        originalId: id,
        type,
        value: `${type}_${id}`,
        label: consumable,
      }))

      this.setState({ consumableOptions })
    }
  }

  handleFormSubmit = (data) => {
    const {
      itemsToBeCharged,
    } = this.state
    const {
      concept_id: conceptValue,
      is_retention,
      quantity,
    } = data
    // `conceptValue` is the synthetic `${type}_${id}` value from the select —
    // it uniquely identifies the record, unlike the raw `id` which can collide
    // between CenterConsumable and TuitionFeeType.
    const [consum] = this.props.consumables.filter(
      consumable => `${consumable.type}_${consumable.id}` === conceptValue,
    )
    const {
      id: concept_id,
      type: consumableText,
      consumable,
      subtotal_price,
      tax_amount,
      total_price,
    } = consum

    itemsToBeCharged.push({
      id: concept_id,
      quantity,
      is_retention: is_retention !== undefined ? !is_retention : false,
      total_price, // consumable.unit_price
      total: quantity * total_price,
      concept: consumable,
      unit_price: quantity * subtotal_price,
      iva_amount: quantity * tax_amount,
      amount: quantity * total_price,
      description: consumable,
      type: consumableText,
      created_at: Date.now(),
    })

    this.setState({
      itemsToBeCharged,
      // TODO: Clear values after adding a new charge.
      //       SelectSearch component in Playdoh needs to be updated to support passing of values.
      // selectedConsumable: ' ',
      // selectedQty: '',
    })
  }

  removeCharge = (id) => {
    const itemsToBeCharged = clone(this.state.itemsToBeCharged)
    const chargeIndex = findIndex(propEq('id', id))(itemsToBeCharged)

    itemsToBeCharged.splice(chargeIndex, 1)
    this.setState({ itemsToBeCharged })
  }

  handleFormChange = ({ concept_id, quantity }) => {
    this.setState({
      selectedConsumable: concept_id,
      selectedQty: quantity,
    })
  }

  formatAndSubmitCharges = () => {
    const {
      createCharge,
      student,
    } = this.props

    const finalCharges = this.state.itemsToBeCharged.map(({
      id,
      is_retention,
      quantity,
      type,
    }) => ({
      id,
      is_retention,
      quantity: Number(quantity),
      type,
    }))

    createCharge(student.id, finalCharges)
  }

  beforeClose = () => {
    this.setState({
      itemsToBeCharged: [],
      selectedConsumable: '',
      selectedQty: '',
    }, this.props.onClose())
  }

  handleTypeChange = e => this.setState({ type: e.currentTarget.value })

  renderAddChargeFields = () => {
    const {
      student,
    } = this.props
    const {
      consumableOptions,
      selectedConsumable,
      selectedQty,
    } = this.state
    const canPayViaRetention = student && student.product && student.product.type === 'ContractProduct'
    const isAddButtonDisabled = selectedConsumable === '' || selectedQty === ''

    return (
      <InputRow>
        <ConceptInputs>
          <SelectSearch
            name="concept_id"
            label="Concepto"
            options={consumableOptions}
            value={selectedConsumable}
          />
        </ConceptInputs>
        <QuantityInput>
          <TextInput
            name="quantity"
            label="Cantidad"
            type="number"
            value={selectedQty}
          />
        </QuantityInput>
        {canPayViaRetention && (
          <Checkbox
            large
            invertedColors
            hideEmptyHelpBlock
            name="is_retention"
            label="Cargo Directo"
            value={!student.pays_by_retention}
          />
        )}
        <Button primary type="submit" disabled={isAddButtonDisabled}>+ Agregar</Button>
      </InputRow>
    )
  }

  render() {
    const {
      currency,
      isOpen,
      isLoading,
      onClose,
    } = this.props
    const {
      itemsToBeCharged,
    } = this.state

    return (
      <Modal
        isOpened={isOpen}
        onClose={this.beforeClose}
        headerTitle="Agregar Cargo"
        statePath="balance"
        actionType="create"
        typePrefix="BALANCE"
      >
        <Form onSubmit={this.handleFormSubmit} onChange={this.handleFormChange}>
          {this.renderAddChargeFields()}
          <ChargesTable
            charges={itemsToBeCharged}
            currency={currency}
            removeCharge={this.removeCharge}
          />
          <ButtonsContainer>
            <Button
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              primary
              loading={isLoading}
              disabled={itemsToBeCharged.length === 0}
              onClick={this.formatAndSubmitCharges}
            >
              Confirmar
            </Button>
          </ButtonsContainer>
        </Form>
      </Modal>
    )
  }
}

AddChargeModal.propTypes = {
  /** An array of all consumables available at the current center */
  consumables: PropTypes.array.isRequired,
  /** The currency being used. Includes the currency code (e.g. MXN) and symbol (e.g. $) */
  currency: PropTypes.object,
  /** Indicates whether the modal should be displayed or hidden */
  isOpen: PropTypes.bool,
  /** Loading flag */
  isLoading: PropTypes.bool.isRequired,
  /** The active student */
  student: PropTypes.object.isRequired,

  /** Attempt to store a new charge for the active student */
  createCharge: PropTypes.func.isRequired,
  /** Fetch a listing of consumables for the active student */
  getConsumables: PropTypes.func.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
}

AddChargeModal.defaultProps = {
  currency: {},
  isOpen: false,
}

const mapStateToProps = state => ({
  consumables: state.consumables.get.results,
  currency: state.centers.getOne.result && state.centers.getOne.result.currency,
  isLoading: state.balance.create.fetching,
  student: ClassroomSelectors.activeStudent(state),
  user:  ClassroomSelectors.activeUser(state , state.classrooms.center_id),
})

const mapDispatchToProps = dispatch => ({
  createCharge: (studentId, itemsToBeCharged) =>
    dispatch(BalanceActions.createChargeRequest(studentId, itemsToBeCharged)),

  getConsumables: (centerId, studentId) =>
    dispatch(ConsumbalesActions.getStudentConsumablesRequest(centerId, studentId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddChargeModal)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/AddChargeModal.jsx